import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-breadcrumb-author',
  templateUrl: './breadcrumb-author.component.html',
  styleUrls: ['./breadcrumb-author.component.scss']
})
export class BreadcrumbAuthorComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
